export default __webpack_public_path__ + "static/media/app_iknow99.9c3d3365.png";